import { AxiosResponse } from "axios";
import { api, RouteAPI } from "../service/apiService";

export interface Profession {
    id: number;
    name: string;
    translations?: Record<string, string>;
}

export async function getProfessions(): Promise<Profession[]> {
    const response: AxiosResponse<Profession[]> = await api(
        RouteAPI.PROFESSIONS,
        "GET"
    );
    return response.data;
}
